<template>
    <template v-if="isFileOverPages">
      <span class="file-over-pages-warning text--x-small" v-bind="$attrs">
        <span v-if="textInline" class='mx-1'>-</span>
        <app-icon-ds
            icon="fa-exclamation-triangle"
            weight="fas"
            size="xxs"
            class="text-warning mr-1 pb-1"
        />
        <span>{{ t('overPages', { maxSignablePages }) + t('toChangeFile')}}</span>
      </span>
    </template>
    <template v-if="prepareSignatureOverPages">
        <app-icon-ds
            icon="fa-exclamation-triangle"
            size="lg"
            class="mb-5 text-grey-600"
        />
        <h2 class="text-center mb-2">{{ t('overPages', { maxSignablePages }) }}</h2>
        <p class="text-center">{{ t('toChangeFile') }}</p>
    </template>
</template>

<script setup lang="ts">
import { computed, PropType, watchEffect } from 'vue'

import { useTranslation } from '@/common/utils/translation'
import { SigningChecklistFile } from '@/project/views/SigningChecklistAdd.vue'

const { t } = useTranslation({ keyPrefix: 'project.signing-checklist.SigningChecklistOverPagesWarning' })

const props = defineProps({
  file: {
    type: Object as PropType<SigningChecklistFile>,
    required: false,
    default: () => ({}),
  },
  textInline: {
    type: Boolean,
    default: false,
  },
  prepareSignatureOverPages: {
    type: Boolean,
    default: false,
  },
})

const maxSignablePages = Number(import.meta.env.VUE_APP_MAX_SIGNABLE_PAGES)

const isFileOverPages = computed(() => {
  const nbPages = Number(
    props.file.originalFile?.nbPages ??
    props.file.nbPages ??
    props.file.objectToPost?.envelope?.file?.nbPages,
  )
  return nbPages > maxSignablePages
})

const emit = defineEmits(['update:isFileOverPages'])
watchEffect(() => {
  emit('update:isFileOverPages', isFileOverPages.value)
})
</script>
  
<style scoped>
  .file-over-pages-warning {
    display: flex;
    align-items: center;
  }
</style>
  